import { ADCASH_ENABLED, ADCASH_ZONE_ID } from "../config/ads.js";

const SCRIPT_ID = "aclib";
let libraryPromise = null;
let autotagPromise = null;

const isProductionHost = () =>
  !["localhost", "127.0.0.1", "0.0.0.0"].includes(window.location.hostname);

export function canLoadAdcash() {
  return ADCASH_ENABLED && isProductionHost();
}

export function loadAdcashLibrary() {
  if (!ADCASH_ENABLED || !isProductionHost()) return Promise.resolve(false);
  if (window.aclib) return Promise.resolve(true);
  if (libraryPromise) return libraryPromise;

  libraryPromise = new Promise((resolve, reject) => {
    const finish = () => {
      if (!window.aclib) {
        reject(new Error("A biblioteca Adcash não ficou disponível."));
        return;
      }
      resolve(true);
    };

    const existing = document.getElementById(SCRIPT_ID);
    if (existing) {
      if (window.aclib) finish();
      else {
        existing.addEventListener("load", finish, { once: true });
        existing.addEventListener(
          "error",
          () => reject(new Error("Falha ao carregar a biblioteca Adcash.")),
          { once: true },
        );
      }
      return;
    }

    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.type = "text/javascript";
    script.src = "https://acscdn.com/script/aclib.js";
    script.async = true;
    script.addEventListener("load", finish, { once: true });
    script.addEventListener(
      "error",
      () => reject(new Error("Falha ao carregar a biblioteca Adcash.")),
      { once: true },
    );
    document.head.appendChild(script);
  }).catch((error) => {
    libraryPromise = null;
    throw error;
  });
  return libraryPromise;
}

export function loadAdcashAutotag() {
  if (window.__partyverseAdcashStarted) return true;
  if (autotagPromise) return autotagPromise;

  autotagPromise = loadAdcashLibrary()
    .then((loaded) => {
      if (!loaded) return false;
      if (!window.aclib?.runAutoTag) {
        throw new Error("O AutoTag da Adcash não ficou disponível.");
      }
      window.aclib.runAutoTag({ zoneId: ADCASH_ZONE_ID });
      window.__partyverseAdcashStarted = true;
      return true;
    })
    .catch((error) => {
      autotagPromise = null;
      throw error;
    });
  return autotagPromise;
}

export async function renderAdcashBanner(container, zoneId) {
  if (!container || !zoneId) return false;
  const loaded = await loadAdcashLibrary();
  if (!loaded) return false;
  if (!container.isConnected) return false;
  if (!window.aclib?.runBanner) {
    throw new Error("Os banners da Adcash não ficaram disponíveis.");
  }
  if (container.dataset.adcashRenderedZone === zoneId) return true;

  container.dataset.adcashRenderedZone = zoneId;
  const runner = document.createElement("script");
  runner.type = "text/javascript";
  runner.dataset.adcashRunner = zoneId;
  runner.text = `aclib.runBanner(${JSON.stringify({ zoneId })});`;
  container.appendChild(runner);
  return true;
}
